import { defa }      from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from 'templates/controlDetails.jst.html';

const selectors = {
	regionContainer : '[data-region=details-container]',
	toggleButton    : '[data-toggle=expand-spoiler]',
	upgradeButton   : '[data-click=upgrade-firmware]',
};

const channel = Bb.Radio.channel( 'objects' ),
channelLayout = Bb.Radio.channel( 'layout' );


const ControlDetailsView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:details',
	compressedNavState: 'unit:control:overview',
	
	className: function () {
		return this._getClassName( 'control-details' );
	},
	
	ui: {
		toggle          : selectors.toggleButton,
		upgradeFirmware : selectors.upgradeButton,
	},
	
	events: {
		'click @ui.toggle'          : 'onClickToggle', // super
		'click @ui.upgradeFirmware' : 'onClickUpgradeFirmware',
	},
	
	modelEvents: {
		'change:transientOffline': 'onConnectionChanged',
		'change:transientUpgradeAvailable': 'onUpgradeAvailableChanged',
		'change:transientApiVersion' : 'onApiVersionChanged',
	},
	
	templateContext: function () {
		const superContext = ControlModule.prototype.templateContext.call(this);
		
		return _.extend(superContext, {
			serial              : this.model.get( 'serialNumber' ) || '&nbsp;',
			showSerialNumber    : true,
			showTestResult      : true,
			showApiVersion      : this.model.get( 'transientApiVersion' ) !== null,
			apiVersion          : this.model.get( 'transientApiVersion' ) || '&nbsp',
			upgradeAvailable    : this.model.get( 'transientUpgradeAvailable' ),
			offline             : this.model.get( 'transientOffline' ),
			unitType            : this.model.getUnitType(),
			subscriptionName    : this.model.subscriptionName(),
			customerName        : this.model.customerName(),
			vehicleName         : this.model.vehicleName(),
			alarmCentralName    : this.model.alarmCentralName(),
			insuranceCompanyName: this.model.insuranceCompanyName(),
		});
	},
	
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the model changes the transientOffline attribute.
	 * @void
	 */
	onConnectionChanged: function( event ) {
		this.evaluateUpgradeButton();
	},
	
	/**
	 * Triggers when the model changes the transientUpgradeAvailable attribute.
	 * @void
	 */
	onUpgradeAvailableChanged: function( event ) {
		this.evaluateUpgradeButton();
	},
	
	/**
	 * Triggers when the model changes the transientApiVersion attribute.
	 * @void
	 */
	onApiVersionChanged: function( event ) {
		if(this.$el.find('.api-version')) {
			this.$el.find('.api-version').html(this.model.get( 'transientApiVersion' ));
		} else {
			this.render();
		}
	},

	
	/**
	 * Triggers when the user clicks the "upgrade" button.
	 * @void
	 */
	
	onClickUpgradeFirmware : function ( ) {
		event.preventDefault();
		this.trigger( 'upgrade', this);
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	evaluateUpgradeButton: function () {
		let offline = this.model.get('transientOffline'),
		 upgradeAvailable = this.model.get('transientUpgradeAvailable'),
		 upgradeButtonHidden = this.$el.find('.upgrade-button').hasClass('no-upgrade');
		
		if( !offline && upgradeAvailable && upgradeButtonHidden) {
			this.$el.find('.upgrade-button').removeClass('no-upgrade');
		} else if((!upgradeAvailable && !upgradeButtonHidden) ||
				  (offline && !upgradeButtonHidden)) {
			this.$el.find('.upgrade-button').addClass('no-upgrade')
		}
		
	},
	
} );


export default ControlDetailsView;